import type { IFilter } from '@/types/Data'
import type { IGetFilterList, IPayloadFilter } from '@/types/Request'
import BaseService from '../BaseService'

export default class FilterServices extends BaseService {
  GetFilterList(payload: IGetFilterList) {
    return this.GET<IFilter[]>(this.PATHS.GET_FILTER_LIST, payload)
  }

  GetFiltersWithCriteria(payload: IGetFilterList) {
    return this.GET<IFilter[]>(this.PATHS.GET_FILTERS_WITH_CRITERIA, payload)
  }

  CreateFilter(data: IPayloadFilter) {
    return this.POST<IFilter>(this.PATHS.CREATE_FILTER, data)
  }

  UpdateFilter(data: IPayloadFilter) {
    return this.PUT<IFilter>(this.PATHS.UPDATE_FILTER, data)
  }

  DeleteFilter(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_FILTER, null, { Id })
  }
}
